<template>
  <div id="page-onboarding" class="processes d-flex">
    <MainBarMenu />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="row mt-5">
        <div class="col-md-6 pt-4">
          <h2 class="mb-4">NUEVO REPORTE DISCIPLINARIO</h2>
          <div class="alert alert-warning text-center mb-4">
            <div>
              El <span class="font-weight-bold">copy</span> de creación del
              reporte nuevo va acá
            </div>
          </div>
          <template>
            <div class="accordion mx-auto" role="tablist">
              <b-card no-body class="mb-4">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-1>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="validGeneralData"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Datos generales del reporte
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr class="">
                          <td valign="top">
                            <span v-if="user.core_role_id != '2'"
                              >Business Partner</span
                            ><span v-else>Coordinador *</span>
                          </td>
                          <td width="20"></td>
                          <td width="55%" class="text-left">
                            <span v-if="user.core_role_id != '2'">{{
                              businessPartner.name
                            }}</span>
                            <vue-bootstrap-typeahead
                              v-else
                              class="typehead typehead-relative"
                              placeholder="Escribe el nombre del coordinador..."
                              v-model="coordinatorSearch"
                              :data="listCoordinators"
                              @hit="selectedCoordinator($event)"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Fecha de conocimiento de la falta *
                            <br />
                            <small
                              v-if="!validDateKnowledge"
                              class="alert-danger"
                              >Fecha invalida</small
                            >
                          </td>

                          <td width="30"></td>
                          <td class="text-left date">
                            <div>
                              <input
                                minlength="2"
                                maxlength="2"
                                min="1"
                                max="31"
                                class="input-1"
                                type="text"
                                placeholder="dd"
                                v-model="report.day"
                                @change="valDay('knowledge')"
                              />
                              <select
                                v-model="report.month"
                                class="select-1 px-1"
                              >
                                <option
                                  v-for="item in months"
                                  :value="item.id"
                                  :key="item.id"
                                >
                                  {{ item.name }}
                                </option>
                              </select>
                              <select
                                v-model="report.year"
                                class="select-1 px-1"
                              >
                                <option :value="year">
                                  {{ year }}
                                </option>
                                <option :value="year - 1">
                                  {{ year - 1 }}
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Fecha de la presunta falta
                            <br />
                            <small v-if="!validDateFailure" class="alert-danger"
                              >Fecha invalida</small
                            >
                          </td>
                          <td width="30"></td>
                          <td class="text-left date">
                            <div>
                              <input
                                minlength="2"
                                maxlength="2"
                                class="input-1"
                                type="text"
                                placeholder="dd"
                                v-model="report.dayFailure"
                                @change="valDay('failure')"
                              />
                              <select
                                v-model="report.monthFailure"
                                class="select-1 px-1"
                                required
                              >
                                <option value="" hidden disabled selected>
                                  mm
                                </option>
                                <option
                                  v-for="item in months"
                                  :value="item.id"
                                  :key="item.id"
                                >
                                  {{ item.name }}
                                </option>
                              </select>
                              <select
                                v-model="report.yearFailure"
                                class="select-1 px-1"
                                required
                              >
                                <option value="" hidden disabled selected>
                                  yyyy
                                </option>
                                <option :value="year">
                                  {{ year }}
                                </option>
                                <option :value="year - 1">
                                  {{ year - 1 }}
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Prioridad *</td>
                          <td width="20"></td>
                          <td class="text-left">
                            <span v-if="process.id != 0">Alta</span>
                            <div v-else>
                              <label class="mr-5">
                                <input
                                  name="priority"
                                  type="radio"
                                  value="13"
                                  v-model="report.util_priority_id"
                                />
                                Alta
                              </label>
                              <label class="mr-5">
                                <input
                                  name="priority"
                                  type="radio"
                                  value="12"
                                  v-model="report.util_priority_id"
                                />
                                Media
                              </label>
                              <label class="mr-5">
                                <input
                                  name="priority"
                                  type="radio"
                                  value="11"
                                  v-model="report.util_priority_id"
                                />
                                Leve
                              </label>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Personas asociadas al reporte *</td>
                          <td width="20"></td>
                          <td class="text-left">
                            <table class="n-padding w-100" border="1">
                              <thead>
                                <tr>
                                  <td>Nombre</td>
                                  <td>ID Sharp</td>
                                  <td>Site</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="employee in selectedEmployees"
                                  :key="employee.id"
                                >
                                  <td>{{ employee.name }}</td>
                                  <td>{{ employee.sharp_id }}</td>
                                  <td>{{ employee.site.name }}</td>
                                </tr>
                                <!--tr v-if="process.id == 0">
                                  <td colspan="3"></td>
                                </tr-->
                              </tbody>
                            </table>
                            <vue-bootstrap-typeahead
                              class="typehead typehead-n-border typehead-relative"
                              placeholder="Busca un colaborador..."
                              v-model="employeeSearch"
                              :data="listEmployeesCoordinator"
                              @hit="selectedEmployee($event)"
                              ref="employeeAutocomplete"
                            />
                          </td>
                        </tr>
                        <tr class="legend">
                          * Campos obligatorios
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-4">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-2>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="validSupports"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Soportes
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr v-if="user.core_role_id == '2'">
                          <td valign="top">Solicitar soporte adicional</td>
                          <td width="20"></td>
                          <td class="text-left">
                            <div class="form-group">
                              <textarea
                                class="form-control border-gray"
                                rows="4"
                                placeholder="Detalla el tipo de soporte que necesitas..."
                                v-model="report.evidence"
                              ></textarea>
                            </div>
                            <small>Coordinador: {{ coordinatorSearch }}</small>
                          </td>
                        </tr>
                        <tr>
                          <td v-if="process.id == 0" valign="top">
                            Soportes anexos al reporte
                          </td>
                          <td v-if="process.id == 0" width="20"></td>
                          <td class="text-left">
                            <div
                              v-bind:class="
                                process.id == 0 ? 'border-gray' : ''
                              "
                            >
                              <table
                                class="n-padding w-100 no-border"
                                border="1"
                              >
                                <thead>
                                  <tr>
                                    <td>Archivo</td>
                                    <td>Cargado por</td>
                                    <td v-if="process.id != 0">Fecha</td>
                                    <td>Acciones</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(file, index) in selectedFiles"
                                    :key="index"
                                  >
                                    <td>{{ file.name }}</td>
                                    <td>{{ user.name }}</td>
                                    <!--td v-if="process.id != 0">8 Nov, 2020</td-->
                                    <td class="text-center">
                                      <!--a href="">
                                        <span
                                          class="icon icon-descargar mx-1"
                                        ></span>
                                      </a-->
                                      <a @click="deleteFile(file.name)">
                                        <span
                                          class="icon icon-eliminar-2 icon-red mx-1"
                                        ></span>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div
                              v-bind:class="
                                process.id == 0 ? 'text-right' : 'text-center'
                              "
                            >
                              <label
                                :class="
                                  process.id == 0
                                    ? 'add-to-list btn'
                                    : 'btn add-to-list-2'
                                "
                              >
                                <input type="file" @change="selectFile" />
                                Añadir soporte
                              </label>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-4" v-if="process.id != 0">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-3>
                    <span class="mx-4"></span>
                    Procesos disciplinarios asociados
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr class="">
                          <td>
                            <table
                              class="n-padding w-100 no-border text-left"
                              border="1"
                            >
                              <thead>
                                <tr>
                                  <td>Nombre</td>
                                  <td>ID Sharp</td>
                                  <td>Site</td>
                                  <td>Proceso</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Diego Camilo Franco C</td>
                                  <td>368293845</td>
                                  <td>Tocancipá</td>
                                  <td>
                                    <router-link to="/process">
                                      <span class="icon icon-table mx-1"></span>
                                      Sin iniciar
                                    </router-link>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Juan David Pérez</td>
                                  <td>368293845</td>
                                  <td>Tocancipá</td>
                                  <td>
                                    <router-link to="/process">
                                      <span class="icon icon-table mx-1"></span>
                                      Sin iniciar
                                    </router-link>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div class="well-process m-4 mt-5">
                              <div>Concepto de relaciones laborales:</div>
                              <p class="mt-3">
                                <span class="font-weight-bold"
                                  >Diego Camilo Franco C:</span
                                >
                                Iniciar proceso disciplinario
                              </p>
                              <p>
                                <span class="font-weight-bold"
                                  >Juan David Pérez:</span
                                >
                                Cerrar proceso disciplinario
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </template>

          <div v-if="process.id == 0">
            <div class="text-center">
              <b-button
                class="btn btn-principal"
                :disabled="!validGeneralData || !validSupports"
                @click="sendReport"
              >
                <span class="icon icon-upload mr-4"></span>
                Cargar reporte disciplinario
              </b-button>

              <div>
                <b-modal ref="my-modal" hide-footer hide-header centered>
                  <p class="my-4 text-center">
                    <img
                      class="mb-4"
                      width="70"
                      src="@/assets/images/processes/modal-check.png"
                      alt="check"
                    />
                    <br />
                    {{ this.msjModal }}
                  </p>
                  <div class="processes text-center mb-5">
                    <button class="btn btn-principal" @click="hideModal">
                      Continuar
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>
            <div class="text-center">
              <small v-show="error.flag" class="alert-danger">{{
                error.message
              }}</small>
            </div>
          </div>
          <div class="text-center mt-4">
            <p class="copy">
              ¿Cómo puedes escribir un reporte eficiente?
              <span class="link-copy" @click="$bvModal.show('modalHelp')"
                >haz clic aquí</span
              >
            </p>
          </div>

          <b-modal
            id="modalHelp"
            ref="modalHelp"
            class="modal-help"
            hide-footer
            size="md"
            title="Para que el proceso sea fluido, tu reporte debe..."
          >
            <p class="text-center">
              <img
                width="100%"
                src="@/assets/images/processes/help.jpeg"
                alt="check"
              />
            </p>
          </b-modal>
        </div>
        <div class="col-md-6 pt-3 border-left">
          <div class="tab">Reporte</div>
          <Editor v-model="report.letter"></Editor>
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
    </div>
    <!-- .layout-content -->
  </div>
  <!-- #page-onboarding -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Editor from "@/components/general/Editor.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import serverConfig from "./../../services/config";
//import HeadingUser from "@/components/user/HeadingUser.vue";

export default {
  name: "HomeProcesses",
  components: {
    MainBarMenu,
    HeadingUser,
    Editor,
    //HeadingUser,
  },
  data() {
    return {
      template:
        "<p>Coordinador: {{COORDINADOR}}</p><p>Fecha conocimiento: {{FECHA_CONOCIMIENTO}}</p><p>Fecha falta: {{FECHA_FALTA}}</p>",
      serverPath: serverConfig.permisosURL,
      coordinatorSearch: "",
      coordinatorsBP: [],
      listCoordinators: [],
      employeeSearch: "",
      employeesCoordinator: [],
      listEmployeesCoordinator: [],
      selectedEmployees: [],
      year: "",
      report: {
        id: "",
        day: "",
        month: "",
        year: "",
        date_knowledge: "",
        evidence: "",
        letter: "<p><span style='color:hsl(0, 0%, 60%)'><i>Escribe aquí tu reporte…</i></span></p>",
        coordinator: 0,
        business_partner: 0,
        util_priority_id: "",
        data_alleged_failure: "",
        dayFailure: "",
        monthFailure: "",
        yearFailure: "",
      },
      error: {
        flag: false,
        class: "",
        message: "",
      },
      msjModal: "",
      selectedFiles: [],
      months: [
        { id: "01", name: "ENE" },
        { id: "02", name: "FEB" },
        { id: "03", name: "MAR" },
        { id: "04", name: "ABR" },
        { id: "05", name: "MAY" },
        { id: "06", name: "JUN" },
        { id: "07", name: "JUL" },
        { id: "08", name: "AGO" },
        { id: "09", name: "SEP" },
        { id: "10", name: "OCT" },
        { id: "11", name: "NOV" },
        { id: "12", name: "DIC" },
      ],
    };
  },
  beforeMount() {
    let date = new Date();
    this.year = date.getFullYear();
    this.report.year = this.year;
    this.report.month = date.getMonth() + 1;
    this.report.month = String(this.report.month).padStart(2, "0");
  },
  async created() {
    await this.actBP();
    await this.getEmployees(this.user.sharp_id);

    if (this.user.core_role_id == 2) {
      this.coordinatorsBP = await this.actCoordinatorsByBP(this.user.id);
      this.listCoordinators = this.coordinatorsBP.map((employee) => {
        return employee.name;
      });
    } else {
      this.report.coordinator = this.user.id;
    }
    this.report.business_partner = this.userData.site.business_partner;
  },

  computed: {
    ...mapState("modCore", ["user", "userData", "businessPartner"]),
    ...mapState("modProcesses", ["process"]),
    validGeneralData() {
      if (
        this.report.util_priority_id &&
        this.report.day &&
        this.report.month &&
        this.report.year &&
        ((this.report.dayFailure &&
          this.report.monthFailure &&
          this.report.yearFailure) ||
          (!this.report.dayFailure &&
            !this.report.monthFailure &&
            !this.report.yearFailure)) &&
        this.validDateKnowledge &&
        this.validDateFailure &&
        this.selectedEmployees.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    validSupports() {
      return this.selectedFiles.length > 0 || this.report.evidence;
    },
    validDateKnowledge() {
      if (this.report.day && this.report.month && this.report.year) {
        let date = new Date(
          this.report.year + "-" + this.report.month + "-" + this.report.day
        );
        if (date > new Date()) {
          return false;
        }
        return true;
      }
      return true;
    },
    validDateFailure() {
      if (
        this.report.dayFailure &&
        this.report.monthFailure &&
        this.report.yearFailure
      ) {
        let date = new Date(
          this.report.yearFailure +
            "-" +
            this.report.monthFailure +
            "-" +
            this.report.dayFailure
        );
        if (date > new Date()) {
          return false;
        }
        return true;
      }
      return true;
    },
  },
  watch: {
    /*'report.day'(){
      this.setVariableTemplate('fechaConocimiento', this.report.day + "-" + this.report.month + "-" + this.report.year);
    },
    'report.month'(){
      this.setVariableTemplate('fechaConocimiento', this.report.day + "-" + this.report.month + "-" + this.report.year);
    },
    'report.year'(){
      this.setVariableTemplate('fechaConocimiento', this.report.day + "-" + this.report.month + "-" + this.report.year);
    },
    'report.dayFailure'(){
      this.setVariableTemplate('fechaFalta', this.report.dayFailure + "-" + this.report.monthFailure + "-" + this.report.yearFailure);
    },
    'report.monthFailure'(){
      this.setVariableTemplate('fechaFalta', this.report.dayFailure + "-" + this.report.monthFailure + "-" + this.report.yearFailure);
    },
    'report.yearFailure'(){
      this.setVariableTemplate('fechaFalta', this.report.dayFailure + "-" + this.report.monthFailure + "-" + this.report.yearFailure);
    },*/
  },

  methods: {
    ...mapMutations("modProcessEmployee", ["setEditorData"]),
    ...mapActions("modCore", ["actUser", "actBP"]),
    ...mapActions("modProcesses", [
      "actEmployeesByCoordinator",
      "actSaveReport",
      "actSaveReportEvidence",
      "actSaveRequestEvidence",
      "actSaveReportEmployees",
      "actCoordinatorsByBP",
    ]),
    valDay(type) {
      if (type == "knowledge") {
        if (this.report.day > 31) {
          this.report.day = 31;
        }
        this.report.day = String(this.report.day).padStart(2, "0");
      }
      if (type == "failure") {
        if (this.report.dayFailure > 31) {
          this.report.dayFailure = 31;
        }
        this.report.dayFailure = String(this.report.dayFailure).padStart(
          2,
          "0"
        );
      }
    },
    async getEmployees(id) {
      this.employeesCoordinator = await this.actEmployeesByCoordinator(id);
      this.listEmployeesCoordinator = this.employeesCoordinator.map(
        (employee) => {
          return employee.name;
        }
      );
    },
    selectedEmployee(event) {
      if (!this.selectedEmployees.find((employee) => employee.name === event)) {
        const employee = this.employeesCoordinator.find(
          (employee) => employee.name === event
        );
        this.selectedEmployees.push(employee);
      }
      this.employeeSearch = "";
      this.$refs.employeeAutocomplete.inputValue = "";
    },
    async selectedCoordinator(event) {
      const employee = this.coordinatorsBP.find(
        (employee) => employee.name === event
      );
      this.report.coordinator = employee.id;
      //this.setVariableTemplate('coordinador', employee.name);
      await this.getEmployees(employee.sharp_id);
    },
    setVariableTemplate(key, value) {
      this.template = this.template.replace(this.variables[key], value);
      this.variables[key] = value;
    },
    async sendReport() {
      this.report.date_knowledge =
        this.report.year + "-" + this.report.month + "-" + this.report.day;
      if (
        this.report.yearFailure &&
        this.report.monthFailure &&
        this.report.dayFailure
      ) {
        this.report.data_alleged_failure =
          this.report.yearFailure +
          "-" +
          this.report.monthFailure +
          "-" +
          this.report.dayFailure;
      }
      this.report.evidence = this.report.evidence || "*";
      this.report.letter = this.report.letter || "Escribe aqui tu reporte";
      let response = await this.actSaveReport(this.report);
      if (response.error) {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message = "Ocurrio un error al guardar los datos";
      } else {
        this.report.id = response.data.id;
        await this.uploadFiles();
        await this.saveEmployees();
        if (this.report.evidence != "*") {
          await this.saveReqEvidence();
        }
        this.showModal(
          "El reporte disciplinario ha sido cargado con éxito, se te notificará cuando se genere la citación a la diligencia de descargos",
          1
        );
      }
    },
    showModal(msj, flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
      if (this.flagPath == 1) {
        this.$router.push({ path: "/processDetail/" + this.report.id });
      }
    },
    selectFile() {
      this.selectedFiles.push(event.target.files[0]);
    },
    deleteFile(name) {
      this.selectedFiles = this.selectedFiles.filter((file) => file.name != name );
    },
    async uploadFiles() {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        await this.upload(i, this.selectedFiles[i]);
      }
      return true;
    },
    async upload(idx, file) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("proce_report_id", this.report.id);
      await this.actSaveReportEvidence(formData);
      return true;
    },
    async saveEmployees() {
      for (let i = 0; i < this.selectedEmployees.length; i++) {
        await this.actSaveReportEmployees({
          proce_report_id: this.report.id,
          core_employee_id: this.selectedEmployees[i].id,
        });
      }
      return true;
    },
    async saveReqEvidence() {
      await this.actSaveRequestEvidence({
        proce_report_id: this.report.id,
        text: this.report.evidence,
      });
      return true;
    },
  },
};
</script>
<style scoped>
.tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 20px;
  margin-bottom: 5px;
  width: 100px;
  height: 28px;
  background: rgba(28, 103, 118, 0.45);
  border-radius: 5px 5px 0px 0px;
}

input[type="file"] {
  opacity: 0;
  filter: alpha(opacity=0);
  display: block;
  width: 360px;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.legend {
  font-style: italic;
  font-size: 12px;
  color: #808080;
}

.copy {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #1c3a4e;
}

.link-copy {
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
}

select:required:invalid {
  color: gray !important;
}

@media (min-width: 992px) {
  .modal-help {
    max-width: 700px !important;
  }
}
</style>
